// The Non-Penyedia part of Buat project (shell/Projects.tsx): the project
// kind (Paket PBJ, the default, or a plain Folder) and, for a Paket PBJ, the
// paket data (PaketFields: route with its method or Swakelola type, unit
// kerja, jenis pengadaan, tahun anggaran, kode RUP, pagu).
import { useId } from "react";
import { defaultPaketForm, PaketFields, type PaketForm } from "./PaketFields";

export interface PbjChoice extends PaketForm {
  kind: "pbj" | "folder";
}

export const DEFAULT_PBJ_CHOICE: PbjChoice = { kind: "pbj", ...defaultPaketForm() };

export function PbjCreateFields({ value, onChange, disabled }: { value: PbjChoice; onChange: (next: PbjChoice) => void; disabled?: boolean }) {
  const id = useId();
  const set = (patch: Partial<PbjChoice>) => onChange({ ...value, ...patch });
  return (
    <div className="pbj-create">
      <fieldset className="pbj-choice" disabled={disabled}>
        <legend className="pbj-legend">Jenis project</legend>
        <label className="pbj-option">
          <input type="radio" name={`${id}-kind`} checked={value.kind === "pbj"} onChange={() => set({ kind: "pbj" })} />
          <span className="pbj-option-text">
            <span className="pbj-option-title">Paket PBJ</span>
            <span className="pbj-option-hint">Tahap PBJ dari rencana kerja dan anggaran sampai serah terima, dengan aktivitas tiap tahap, dicentang oleh pelakunya.</span>
          </span>
        </label>
        <label className="pbj-option">
          <input type="radio" name={`${id}-kind`} checked={value.kind === "folder"} onChange={() => set({ kind: "folder" })} />
          <span className="pbj-option-text">
            <span className="pbj-option-title">Folder</span>
            <span className="pbj-option-hint">Kumpulan chat dan file pengadaan saja.</span>
          </span>
        </label>
      </fieldset>
      {value.kind === "pbj" ? <PaketFields value={value} onChange={(next) => onChange({ ...next, kind: value.kind })} disabled={disabled} /> : null}
    </div>
  );
}
